import { render, staticRenderFns } from "./TopicsCategoriesButton.vue?vue&type=template&id=9bfa0682&scoped=true&"
import script from "./TopicsCategoriesButton.vue?vue&type=script&lang=js&"
export * from "./TopicsCategoriesButton.vue?vue&type=script&lang=js&"
import style0 from "./TopicsCategoriesButton.vue?vue&type=style&index=0&id=9bfa0682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa0682",
  null
  
)

export default component.exports